"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionContext = void 0;
const converter_1 = require("./converter");
class ConversionContext {
    constructor() {
        this._currentRibbonIndex = ConversionContext.UnsetIndex;
        this._currentMenuIndex = ConversionContext.UnsetIndex;
        this._currentTabIndex = ConversionContext.UnsetIndex;
        this._currentGroupIndex = ConversionContext.UnsetIndex;
        this._currentCustomMobileGroupIndex = ConversionContext.UnsetIndex;
        this._currentControlIndex = ConversionContext.UnsetIndex;
        this._currentFixedControlIndex = ConversionContext.UnsetIndex;
        this._currentMenuItemIndex = ConversionContext.UnsetIndex;
        this._currentIconIndex = ConversionContext.UnsetIndex;
        this._currentContextMenuIndex = ConversionContext.UnsetIndex;
        this._currentContextMenuMenuIndex = ConversionContext.UnsetIndex;
        this._currentContextMenuMenuControlIndex = ConversionContext.UnsetIndex;
        this._currentContextMenuMenuControlMenuItemIndex = ConversionContext.UnsetIndex;
        this._currentCommandSurfaceType = converter_1.CommandSurfaceType.None;
        this._isInFixedControl = false;
        this._hostType = null;
        this._inputFormFactor = null;
    }
    getFormFactor() {
        return this._inputFormFactor;
    }
    setFormFactor(formFactor) {
        this._inputFormFactor = formFactor;
    }
    getManifestHostType() {
        return this._hostType;
    }
    setManifestHostType(hostType) {
        this._hostType = hostType;
    }
    getCurrentFunctionFileResid() {
        return this._currentFunctionFileResid;
    }
    setCurrentFunctionFileResid(currentFunctionFileResid) {
        this._currentFunctionFileResid = currentFunctionFileResid;
    }
    getCurrentVersionOverrideCapabilities() {
        return this._currentVersionOverrideCapabilities;
    }
    getCurrentVersionOverrideNumber() {
        return this._currentVersionOverrideNumber;
    }
    setCurrentVersionOverrideAndCapabilities(versionOverrideNumber, versionOverrideCapabilities) {
        this._currentVersionOverrideNumber = versionOverrideNumber;
        this._currentVersionOverrideCapabilities = versionOverrideCapabilities;
    }
    getCurrentRibbonIndex() {
        return this._currentRibbonIndex;
    }
    setCurrentRibbonIndex(ribbonIndex) {
        this._currentRibbonIndex = ribbonIndex;
    }
    getCurrentMenuIndex() {
        return this._currentMenuIndex;
    }
    setCurrentMenuIndex(menuIndex) {
        this._currentMenuIndex = menuIndex;
    }
    getCurrentTabIndex() {
        return this._currentTabIndex;
    }
    setCurrentTabIndex(tabIndex) {
        this._currentTabIndex = tabIndex;
    }
    getCurrentGroupIndex() {
        return this._currentGroupIndex;
    }
    setCurrentGroupIndex(groupIndex) {
        this._currentGroupIndex = groupIndex;
    }
    getCurrentCustomMobileGroupIndex() {
        return this._currentCustomMobileGroupIndex;
    }
    setCurrentCustomMobileGroupIndex(customMobileGroupIndex) {
        this._currentCustomMobileGroupIndex = customMobileGroupIndex;
    }
    getCurrentControlIndex() {
        return this._currentControlIndex;
    }
    setCurrentControlIndex(controlIndex) {
        this._currentControlIndex = controlIndex;
    }
    getCurrentMenuItemIndex() {
        return this._currentMenuItemIndex;
    }
    setCurrentMenuItemIndex(menuItemIndex) {
        this._currentMenuItemIndex = menuItemIndex;
    }
    setCurrentCommandSurfaceType(commandSurfaceType) {
        this._currentCommandSurfaceType = commandSurfaceType;
    }
    getCurrentContextMenuIndex() {
        return this._currentContextMenuIndex;
    }
    setCurrentContextMenuIndex(contextMenuIndex) {
        this._currentContextMenuIndex = contextMenuIndex;
    }
    getCurrentContextMenuMenuIndex() {
        return this._currentContextMenuMenuIndex;
    }
    setCurrentContextMenuMenuIndex(contextMenuMenuIndex) {
        this._currentContextMenuMenuIndex = contextMenuMenuIndex;
    }
    getCurrentContextMenuMenuControlIndex() {
        return this._currentContextMenuMenuControlIndex;
    }
    setCurrentContextMenuMenuControlIndex(contextMenuMenuControlIndex) {
        this._currentContextMenuMenuControlIndex = contextMenuMenuControlIndex;
    }
    getCurrentContextMenuMenuControlMenuItemIndex() {
        return this._currentContextMenuMenuControlMenuItemIndex;
    }
    setCurrentContextMenuMenuControlMenuItemIndex(contextMenuMenuControlMenuItemIndex) {
        this._currentContextMenuMenuControlMenuItemIndex = contextMenuMenuControlMenuItemIndex;
    }
    getCurrentIconIndex() {
        return this._currentIconIndex;
    }
    setCurrentIconIndex(iconIndex) {
        this._currentIconIndex = iconIndex;
    }
    getCurrentFixedControlIndex() {
        return this._currentFixedControlIndex;
    }
    setCurrentFixedControlIndex(fixedControlIndex) {
        this._currentFixedControlIndex = fixedControlIndex;
    }
    setInFixedControl(isInFixedControl) {
        this._isInFixedControl = isInFixedControl;
    }
    isInFixedControl() {
        return this._isInFixedControl;
    }
    isInRibbon() {
        return this._currentCommandSurfaceType == converter_1.CommandSurfaceType.Ribbon;
    }
}
exports.ConversionContext = ConversionContext;
ConversionContext.UnsetIndex = -1;
//# sourceMappingURL=conversionContext.js.map